module.exports = __webpack_public_path__ + "static/media/fight.2cd45e61.png";